import { PositionsTable } from "@/services/backend/htz/position/components/positions-table";
import {
  PositionsTableContext,
  PositionsTableContextInterface,
} from "@/services/backend/htz/position/components/positions-table-context";
import { useConfirmationContext } from "@/routes/processes/[processId]/htz/confirmations/[confirmationId]/_components/confirmation-context";
import { useMemo } from "react";

export function PositionsRoute() {
  const {
    confirmation,
    onConfirmationChange,
    positionCatalog,
    airHandlingUnits,
    validationError,
    setValidationError,
  } = useConfirmationContext();

  const value: PositionsTableContextInterface = useMemo(
    () => ({
      positions: confirmation.positions,
      onPositionsChange: (positions) =>
        onConfirmationChange({ ...confirmation, positions }),
      immutable: confirmation.immutable,
      validationError,
      setValidationError,
      positionCatalog,
      airHandlingUnits,
    }),
    [
      confirmation,
      onConfirmationChange,
      validationError,
      setValidationError,
      positionCatalog,
      airHandlingUnits,
    ],
  );

  return (
    <PositionsTableContext.Provider value={value}>
      <PositionsTable />
    </PositionsTableContext.Provider>
  );
}
